import { makeStyles } from "@material-ui/core";
import React from "react";
import CardStep from './cardStep';

let useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent:'spce-between',
        flexWrap: 'wrap',
        flexDirection: 'column',
        ...theme.grid.gridMdContent,
        width: "100%",
        maxWidth: '100%',
        backgroundColor:'#F6F7FF',
        padding:'100px 10px',
        '@media (max-width:500px)': {
            padding:'50px 10px',

        },
    },
    gridConent:{
        display: 'flex',
        alignItems: 'center',
        justifyContent:'space-around',
        ...theme.grid.gridMdContent,
        minWidth:960,
        '@media (max-width:1001px)': {
            minWidth:'100%',
            justifyContent:'center',
            flexDirection:'column'
        },
        '@media (max-width:445px)': {
            textAlign: 'center',
        },
    },
    line: {
        borderRadius: 3,
        height: 4,
        border: 'none',
        backgroundColor: theme.palette.light.type2,
        position: 'absolute',
        top: -15,
        width: 30,
        right: '50%',
    },
    gridTitle: {
        position: 'relative',
    },
    title: {
        fontSize: 28,
        marginBottom: 10,
        '@media (max-width:500px)': {
            textAlign: 'center',
        },
    },
}))

export default function Index() {

    let classes = useStyles();

    return (
        <div className={classes['root']}>
            <div className={classes['gridTitle']}>
                <div className={classes['line']} />
                <h3 className={classes['title']}>
                فرآیند اخذ کد معاملاتی بورس انرژی
                </h3>
            </div>
            <div className={classes['gridConent']}>
                <CardStep data={dataStepUser} />
            </div>
        </div>
    );
}


let dataStepUser = {
    title: '',
    iconTitle: "/assets/icons/kala/profile.svg",
    btnDesc: 'اطلاعات بیشتر',
    link: 'افتتاح حساب وکالتی و صدور کد معاملاتی',
    data: [
        {
            title: 'مراجعه به واحد بورس انرژی پویان',
        },
        {
            title: 'تکمیل فرم‌های احراز هویت مشتریان',
        },
        {
            title: `ارائه مدارک هویتی و ثبت شرکت
            به کارگزاری`,
        },
        {
            title:'ارسال مدارک به شرکت سپرده‌گذاری مرکزی توسط کارگزاری',
        },
        {
            title:'صدور کد معاملاتی توسط سپرده‌گذاری و ارسال برای مشتری',
        },
    ]
} 


